export const load = () => ({
	title: 'Soundproofing Performance Data',
	showTitle: true,
});
